module.exports = __webpack_public_path__ + "img/icon-core3-2.521d7f86.png";